import '@stripe-internal/sail/sail.css';

import {Provider} from '@sail/theme-classic';
import {createContext, useContext} from 'react';
import {DefaultTheme, Theme} from './theme';

const ThemeContext = createContext<Theme>(DefaultTheme);

type Props = {
  value?: Theme;
  overrides?: Partial<Theme>;
  children: React.ReactNode;
};

export function ThemeProvider({
  value = DefaultTheme,
  overrides = {},
  children,
}: Props) {
  const theme = {...value, ...overrides};
  return (
    <Provider>
      <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
    </Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
